/**
 * Miniatura de um anexo de obra.
 *
 * Os anexos não são servidos publicamente — uma planta diz onde a pessoa
 * mora e como lá entrar. Por isso não se pode pôr o URL num <img src>: é
 * preciso ir buscá-lo com o token e mostrar o resultado.
 *
 * O objecto URL é libertado ao desmontar; sem isso, abrir a triagem vinte
 * vezes deixava vinte imagens presas na memória do browser.
 */
import React, { useEffect, useState } from 'react';
import { FileText, ImageOff, Loader2 } from 'lucide-react';
import api from '../utils/api';

const AnexoProjecto = ({ projectId, anexo }) => {
  const [url, setUrl] = useState(null);
  const [falhou, setFalhou] = useState(false);
  const pdf = /\.pdf$/i.test(anexo.ficheiro);

  useEffect(() => {
    let vivo = true;
    let criado = null;

    api.get(`/projects/${projectId}/documents/${anexo.document_id}`, { responseType: 'blob' })
      .then((r) => {
        if (!vivo) return;
        criado = URL.createObjectURL(r.data);
        setUrl(criado);
      })
      .catch(() => { if (vivo) setFalhou(true); });

    return () => { vivo = false; if (criado) URL.revokeObjectURL(criado); };
  }, [projectId, anexo.document_id]);

  const moldura = {
    width: '96px', height: '96px', borderRadius: '10px',
    display: 'grid', placeItems: 'center', overflow: 'hidden',
    background: '#0f172a', border: '1px solid #1e293b', flexShrink: 0,
  };

  if (falhou) {
    return <div style={moldura} title="Não foi possível abrir"><ImageOff className="w-5 h-5 text-slate-600" /></div>;
  }
  if (!url) {
    return <div style={moldura}><Loader2 className="w-4 h-4 animate-spin text-slate-600" /></div>;
  }
  if (pdf) {
    return (
      <a href={url} target="_blank" rel="noreferrer" style={{ ...moldura, textDecoration: 'none' }}
        title={anexo.descricao || 'Documento'}>
        <FileText className="w-6 h-6 text-slate-400" />
      </a>
    );
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" style={moldura} title={anexo.descricao || 'Fotografia'}>
      <img src={url} alt={anexo.descricao || 'Anexo da obra'}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    </a>
  );
};

export default AnexoProjecto;
